<template>
  <div class="shenyunjie-chart-water-drop" :id="id"></div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-liquidfill";
import merge from "deepmerge";

export default {
  name: "YunJieChartWaterDrop",
  props: {
    id: {
      type: String,
      default: function () {
        return new Date().getTime() + "-" + Math.ceil(Math.random() * 1000);
      }
    },
    loadChart: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: 0
    },
    fontSize: {
      type: Number,
      default: 50
    },
    option: {
      type: Object,
      default: function () {
        return {}
      }
    },
    updateOption: {
      type: Function,
      default: null
    }
  },
  components: {},
  data() {
    return {
      chart: null,
      resizeObserver: null
    };
  },
  mounted() {
    let self = this;
    // 窗口大小变化监听
    window.addEventListener("resize", self.resizeWaterDrop);
    // 元素大小变化监听
    self.resizeObserver = new ResizeObserver((entries) => {
      if (self.chart) {
        self.chart.dispose();
        this.chart = null;
      }
      self.init();
    });
    self.resizeObserver.observe(document.getElementById(self.id));
    if (self.loadChart) {
      self.init();
    }
  },
  methods: {
    resizeWaterDrop() {
      let self = this;
      if (self.chart) {
        self.chart.resize();
      }
    },
    init() {
      let self = this;
      // 页面已存在
      if (document.getElementById(self.id) && document.getElementById(self.id).offsetHeight > 0) {
        // 初始化
        if (!self.chart) {
          let theme = self.theme || (this.$YunJie || {}).theme || "standard";
          if (theme == "darkness") {
            self.chart = echarts.init(document.getElementById(self.id), "dark");
          } else {
            self.chart = echarts.init(document.getElementById(self.id));
          }
        }
        // 配置汇总
        let parameter = {
          series: [{
            type: "liquidFill",
            radius: "90%",
            data: [self.value],
            label: {
              formatter: self.title ? function (param) {
                return `${self.title}\n${param.value * 100}%`;
              } : null,
              fontSize: self.fontSize || 50
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: 4,
                borderColor: "#156ACF"
              }
            }
          }]
        };
        let opt = merge({}, parameter);
        // 合并自定义配置
        opt = merge(opt, self.option);
        // 用户自定义属性
        if (self.updateOption) {
          opt = self.updateOption(opt);
        }
        self.chart.setOption(opt, true);
        self.chart.resize();
      }
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWaterDrop);
    this.resizeObserver.disconnect();
  },
  watch: {
    theme() {
      // 销毁已有曲线
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.init();
    },
    title() {
      this.init();
    },
    value() {
      this.init();
    },
    fontSize() {
      this.init();
    },
    option: {
      deep: true,
      handler(option) {
        this.init();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.shenyunjie-chart-water-drop {
  height: 100%;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/charts/waterDrop.vue